import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { DataTableFilterMeta } from "primereact/datatable";

type SolutionFilterState = {
  filters: DataTableFilterMeta;
  setFilters: (filters: DataTableFilterMeta) => void;
  clear: () => void;
};

export const useFilterSolutionStore = create<SolutionFilterState>()(
  persist(
    (set) => ({
      filters: {},
      setFilters: (filters) => set({ filters }),
      clear: () => set({ filters: {} }),
    }),
    { name: "solution-filters" }
  )
);
